import api from "../config/apiConfig";
import { getUserDetails } from "../utils/auth";
import { getRegisterId } from "../utils/authId";

export const viewAccountSummaryApi = async () => {
  const regId = getRegisterId();
  const role = getUserDetails();

  try {
    const response = await api.get(
      `api/get_company_user_overview/?register_id=${regId}&role=${role.role}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
